import axios from 'axios';
import config from '../config/config';

const apiUrl = config.apiBaseUrl;

/**
 * Obtener la tabla principal de solicitudes.
 */
export const getTablaSolicitudes = async (payload, signal) => {
  const { filterData, nombreEmpresa, idEmpresa } = payload;
  try {
    const res = await axios.post(
      `${apiUrl}/tablaSolicitudes?t=${Date.now()}`,
      { filterData, nombreEmpresa, idEmpresa },
      { 
        signal,
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
      }
    );
    return res.data;
  } catch (err) {
    if (err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') throw err;
    throw new Error('Error al cargar datos de la tabla.');
  }
};

/**
 * Verificar el nivel de autorización antes de abrir el modal.
 */
export const verificarNivelAut = async (payload) => {
  const { empresa, centroCosto, departamento, divisa, session, folio } = payload;
  try {
    const res = await axios.post(`${apiUrl}/verificarNivelAut`, {
      empresa,
      centroCosto,
      departamento,
      divisa,
      session,
      folio,
    });
    return res.data;
  } catch (err) {
    throw new Error('Error al verificar el nivel de autorización.');
  }
};

/**
 * Sincronizar datos con el ERP de manera global o por rango/folio.
 */
export const sincronizarERP = async (payload) => {
  const { modo, fechaInicio, fechaFin, folioOC, empresas, soloEntradasPagos } = payload;
  try {
    const resp = await axios.post(`${apiUrl}/sincronizarERP1`, {
      modo,
      fechaInicio,
      fechaFin,
      folioOC,
      empresas,
      soloEntradasPagos,
    });
    return resp.data;
  } catch (err) {
    throw new Error(err.response?.data?.mensaje || err.response?.data?.error || 'Error de servidor al sincronizar ERP.');
  }
};
